module.exports = __webpack_public_path__ + "static/media/Stellar Ora Single Headboard - 120 cm.7fa906e0.jpg";